import { render, staticRenderFns } from "./classifyTreeEdit.vue?vue&type=template&id=8f63c658&scoped=true&"
import script from "./classifyTreeEdit.vue?vue&type=script&lang=js&"
export * from "./classifyTreeEdit.vue?vue&type=script&lang=js&"
import style0 from "./classifyTreeEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./classifyTreeEdit.vue?vue&type=style&index=1&id=8f63c658&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f63c658",
  null
  
)

export default component.exports